import * as THREE from 'three'
import { loadTexture } from '@/utils/loader'

const colors = new Map([
  ['SolidA', 0x8450c3],
  ['SolidB', 0xcb91a1],
  ['SolidC', 0x7e5979]
])

const gradients = new Map([
  ['GradientA', loadTexture(require('@/assets/textures/gradient_a.png'))],
  ['GradientB', loadTexture(require('@/assets/textures/gradient_b.png'))],
  ['GradientC', loadTexture(require('@/assets/textures/gradient_c.png'))],
  ['GradientD', loadTexture(require('@/assets/textures/gradient_d.png'))],
  ['GradientE', loadTexture(require('@/assets/textures/gradient_e.png'))],
  ['GradientF', loadTexture(require('@/assets/textures/gradient_f.png'))],
  ['GradientG', loadTexture(require('@/assets/textures/gradient_g.png'))],
  ['GradientH', loadTexture(require('@/assets/textures/gradient_h.png'))],
  ['GradientI', loadTexture(require('@/assets/textures/gradient_i.png'))],
  ['GradientJ', loadTexture(require('@/assets/textures/gradient_j.png'))],
  ['GradientK', loadTexture(require('@/assets/textures/gradient_k.png'))],
  ['GradientL', loadTexture(require('@/assets/textures/gradient_l.png'))],
  ['GradientM', loadTexture(require('@/assets/textures/gradient_m.png'))]
])

const patterns = new Map([
  ['PatternA', {
    texture: loadTexture(require('@/assets/textures/pattern_a.png')),
    color: 0xfec6ac
  }],
  ['PatternB', {
    texture: loadTexture(require('@/assets/textures/pattern_b.png')),
    color: 0xa8b3ac
  }],
  ['PatternC', {
    texture: loadTexture(require('@/assets/textures/pattern_c.png')),
    color: 0xfff4d5
  }],
  ['PatternD', {
    texture: loadTexture(require('@/assets/textures/pattern_d.png')),
    color: 0xa8b3ac
  }],
  ['PatternE', {
    texture: loadTexture(require('@/assets/textures/pattern_e.png')),
    color: 0xfaad00
  }]
])

const isSolid = name => /^Solid[A-Z]$/.test(name)
const isGradient = name => /^Gradient[A-Z]$/.test(name)
const isPattern = name => /^Pattern[A-Z]$/.test(name)

export const applySolid = (mesh, name) => {
  if (!colors.has(name)) {
    console.error('Unknown solid:', name)
    return
  }

  const color = colors.get(name)
  mesh.material = new THREE.MeshBasicMaterial({ color })
}

export const applyGradient = (mesh, name) => {
  if (!gradients.has(name)) {
    console.error('Unknown gradient:', name)
    return
  }

  const gradient = gradients.get(name)
  mesh.material = new THREE.MeshToonMaterial({
    gradientMap: gradient,
    shininess: 0
  })
}

export const applyPattern = (mesh, name) => {
  if (!patterns.has(name)) {
    console.error('Unknown pattern:', name)
    return
  }
  const pattern = patterns.get(name)
  pattern.texture.wrapT = THREE.RepeatWrapping
  pattern.texture.wrapS = THREE.RepeatWrapping

  mesh.material = new THREE.MeshBasicMaterial({
    alphaMap: pattern.texture,
    color: pattern.color,
    transparent: true
  })
}

export const applyMaterial = mesh => {
  const { name } = mesh.material
  if (isSolid(name)) {
    applySolid(mesh, name)
  } else if (isGradient(name)) {
    applyGradient(mesh, name)
  } else if (isPattern(name)) {
    applyPattern(mesh, name)
  } else {
    console.error('Unknown material:', name)
  }
}
